import React from "react";

/*
 * SCORE BADGE: "80 · hot", white with a black border and the band in the Scoring
 * page's grey ramp (frames 1c, 1d, 1g, 1h; edge states in 1i). Never yellow, red
 * or green: the score is a reading, not a call to act, and those three colours
 * already mean "you, now", "warning" and "won". Never a dash either: with no
 * score (scoring not set up) it renders nothing at all.
 *
 * Featured (new leads, a booked call, a parked company): the four band segments,
 * the ones up to the band filled each in its own grey, the rest an empty grey
 * outline, and the flat shadow; pressed (the shadow gone, the badge moved into
 * it) while the breakdown is open. Small (mid-deal, or a colleague's record): one
 * segment in the band's grey, no shadow. Blocked: "0 · blocked", small, with no
 * segment, because a blocked lead is not low on the ramp, it is off it.
 *
 * Every badge is a button (a click, not a hover, as the brief asks) that toggles
 * the breakdown.
 *
 * Props:
 *   score    scoreView() from record/scoreView.mjs ({ show, label, band, segments, blocked })
 *   size     "featured" | "small"
 *   open     boolean, the breakdown is open (the badge reads pressed)
 *   onClick  () => void, toggles the breakdown
 */
export default function ScoreBadge({ score, size = "featured", open = false, onClick = null }) {
  if (!score || !score.show) return null;
  const common = {
    type: "button",
    onClick: onClick || undefined,
    "aria-expanded": open,
    title: open ? "Close the breakdown" : "Open the breakdown",
  };
  if (score.blocked) {
    return (
      <button {...common} className={`rec-score rec-score--blocked${open ? " is-open" : ""}`}>
        {score.label}
      </button>
    );
  }
  if (size === "small") {
    return (
      <button {...common} className={`rec-score rec-score--small${open ? " is-open" : ""}`}>
        <span className={`rec-score__seg rec-score__seg--${score.band} is-filled`} aria-hidden="true" />
        {score.label}
      </button>
    );
  }
  return (
    <button {...common} className={`rec-score${open ? " is-open" : ""}`}>
      <span className="rec-score__segs" aria-hidden="true">
        {score.segments.map((s) => (
          <span key={s.band} className={`rec-score__seg rec-score__seg--${s.band}${s.filled ? " is-filled" : ""}`} />
        ))}
      </span>
      {score.label}
    </button>
  );
}
